export const UXFB_COOKIE_KEY = 'uxfb_card_satisfaction';

export const UXFB_VISITED_OFFERS_LIMIT = 10;

/** Имя UXFB-события захода на карточку объявления. Должно побайтово совпадать с кампаниями в админке UXFB. */
export const UXFB_EVENT_OPEN_OFFER_CARD = 'open_offer_card';

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
